import {
  createThemedStyled,
  createThemedWithStyle,
  createThemedUseStyletron,
} from "baseui";

// App uses custom theme tokens (textDark, fontBold14, etc.) that are not on
// baseui's default Theme type. Use themed helpers so styled callbacks type-check.
export const styled = createThemedStyled<any>();
export const withStyle = createThemedWithStyle<any>();
export const useStyletron = createThemedUseStyletron<any>();
export { createThemedUseStyletron };
